import { v4 as uuidv4 } from "uuid";

import { WorkspaceMember } from "@/types/workspaceMembers";
import { WorkspaceInvite } from "@/types/workspace-invite";

export type NormalizedWorkspaceInvite = Omit<WorkspaceInvite, "id"> & {
  name: string;
  id: string;
  invitee_id: number;
  email: string;
  expires_at?: string;
};

export type NormalizedWorkspaceMember = Omit<WorkspaceMember, "id"> & {
  name: string;
  id: string;
  email: string;
  user_id: number;
  created_at?: string;
};

export type NormalizedMemberData = NormalizedWorkspaceMember | NormalizedWorkspaceInvite;

export const isWorkspaceInvite = (
  item: NormalizedMemberData | null,
): item is NormalizedWorkspaceInvite =>
  item !== null && "invitee_id" in item && !("last_active" in item);

export const normalizeWorkspaceMembers = (
  members: WorkspaceMember[],
  invitees: WorkspaceInvite[],
): NormalizedMemberData[] => {
  const normalizedMembers: NormalizedWorkspaceMember[] = members.map(member => ({
    ...member,
    id: uuidv4(),
    user_id: member.id || 0,
    name: member.email || "",
    email: member.email || "",
  }));

  return [
    ...normalizedMembers,
    ...invitees.map(invitee => ({
      ...invitee,
      id: uuidv4(),
      invitee_id: invitee.id,
      email: invitee.invitee_email || "",
      name: invitee.invitee_email || "",
    })),
  ] as NormalizedMemberData[];
};
